import { SupportedMessageFormats, MessageChannelsIdToChannel } from "../../contracts";
import { SDQuerySubscribersStore } from "../../Stores";
const formats = {
    [SupportedMessageFormats["jsonrpc2.0"]]: (payload, id) => {
        return {
            channel: id || MessageChannelsIdToChannel[payload.id],
            result: payload.result
        };
    }
};
export function ResponseFormatter(type, payload, id) {
    return formats[type](JSON.parse(payload.data), id);
}
export function SDQResponseFormatter(payload) {
    const p = JSON.parse(payload.data);
    if (p.result === "Unsubscribed") {
        return { channel: "Unsubscribed", result: {} };
    }
    const q = SDQuerySubscribersStore.getQueryByID(p.id);
    return formats[SupportedMessageFormats["jsonrpc2.0"]](p, q);
}
//# sourceMappingURL=ResponseFormatter.js.map